import {Check} from "@mui/icons-material";
import {Alert} from "@mui/material";
import React, {useCallback, useEffect, useState} from "react";


export default function APXSuccessAlert(props) {
	  return (
				 <>
						<Alert icon={<Check fontSize={"inherit"}/>} severity="success" variant={"outlined"} sx={{m: 2, alignItems: "center"}}>
							  {props.message}
						</Alert>
				 </>
	  );
}

export function useSuccessAlert() {
	  const [show, setShow] = useState(false);
	  
	  const callback = useCallback(() => {
			 setTimeout(() => {
					setShow(false);
			 }, 1000);
	  }, []);
	  
	  useEffect(callback, []);
	  
	  return [show, setShow];
}